import React from 'react';
import Page from './Page';
import ShortForm from './ShortForm';
import { Button } from 'material-ui';
import EditIcon from 'material-ui-icons/Edit';
import Link from 'react-router-dom/Link';
import _ from 'lodash';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';


export default class ExperimentResults extends Page {

	static get mustBeResearcher() { return true; }

	constructor(...args) {
		super(...args);
		this.app.resultsForm.loading = true;
		this.downloadFile.bind(this);
	}

	componentDidMount() {
		this.app.resultsForm.load({ experimentId: this.props.match.params.id });
	}

	downloadFile(format){
		this.app.resultsForm.downloadResponses({experimentId:this.props.match.params.id, format});
	}

	render() {

		return (
			<ShortForm
				label={`Experiment Results`}
				formWidth="large"
				waiting={this.app.resultsForm.loading}
			>

				<div style={{position:'relative', minWidth:'780px'}}>
					<div style={{position:'absolute', right:0, top:'-70px', fontSize:'11px'}}>
						<Link to='/send-message'><Button color="primary">CONTACT PARTICIPANTS</Button></Link>
						<Button color="primary" onClick={ () => this.downloadFile('json') }>DOWNLOAD JSON</Button>
						<Button color="primary" onClick={ () => this.downloadFile('csv') }>DOWNLOAD CSV</Button>
						
					</div>
				</div>

				{!this.app.resultsForm.loading &&
					<div>
						<div style={{ fontSize: '24px' }}>
							{this.app.resultsForm.experiment.name}
							<Link title="Edit experiment" to={`/edit-experiment/${this.app.resultsForm.experiment.experimentId}`}>
								<EditIcon style={{marginLeft:'10px', position:'relative', top:'5px'}} />
							</Link>
						</div>
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<div style={{fontSize:'12px'}}>
								<div>Incentive: ${this.app.resultsForm.experiment.incentive || 0}</div>
								<div>Start: {this.app.resultsForm.experiment.start}</div>
								<div>Status: {this.app.resultsForm.experiment.status}</div>
								<div style={{whiteSpace:'pre-line'}}>Audience: <br />{this.app.resultsForm.audience}</div>
							</div>

							<div style={{ width:'400px', display: 'flex', justifyContent: 'space-between' }}>
								<SummaryNumber label="PARTICIPANTS" value={this.app.resultsForm.experiment.numClaims} />
								<SummaryNumber label="COMPLETED" value={this.app.resultsForm.experiment.numResponses } />
								<SummaryNumber label="PARTICIPANT CAP" value={this.app.resultsForm.experiment.participantCap} />
							</div>
						</div>

						<br />
						{this.app.resultsForm.questionResults.map( questionResult => 
							<QuestionSummary key={questionResult.id} data={questionResult} />
						)}
					</div>
				}

			</ShortForm>
		);
	}
}



const CustomizedAxisTick = ({ x, y, stroke, payload }) => (
	<g transform={`translate(${x},${y})`}>
		<text x={0} dx={0} y={0} dy={10} fontSize={10} textAnchor="end" fill="#666" transform="rotate(-30)">{payload.value}</text>
	</g>
);

const CustomizedYAxisTick = ({ x, y, stroke, payload }) => (
	<g transform={`translate(${x},${y})`}>
		<text x={0} dx={0} y={0} dy={4} fontSize={10} textAnchor="end" fill="#666">{_.round(payload.value,1)}</text>
	</g>
);

const QuestionSummary = ({data}) => (
	<div>
		<div style={{ margin: '50px 0 0px 0', fontSize: '18px', borderBottom:'solid 1px #cecece', marginTop:'50px' }}>{data.id}</div>
		<div style={{ margin: '0px 0 10px 0', fontSize: '13px' }}>ID PATH: {data.idPath}</div>
		<div style={{ display: 'flex', justifyContent: 'space-between' }}>
			<SimpleBarChart data={data.responses} label={`TOP ${data.responses.length} RESPONSE${data.responses.length === 1 ? '' : 'S'}`} />
			<SummaryNumber label="AVG TIME" value={`${(data.averageTime / 1000).toFixed(3) }`} />
			<SummaryNumber label="CORRECTNESS" value={data.correctness} />
			
			
		</div>
	</div>
);


const SimpleBarChart = ({ data, label }) => (
	<div style={{ flexShrink: 1 }}>
		<div style={{ margin: '0px 0 0px 0', fontSize: '13px' }}>{label}</div>
		<ResponsiveContainer height={150} width={200}>
			<BarChart data={data} margin={{ top: 5, right: 0, left: -30, bottom: 30 }}>
				<XAxis dataKey="name" tick={<CustomizedAxisTick />} interval={0} stroke="#dedede" />
				<YAxis tick={<CustomizedYAxisTick />} stroke="#dedede" />
				<CartesianGrid vertical={false} stroke="#dedede" />
				<Tooltip />
				<Bar dataKey="value" fill="rgb(74, 134, 232)" />
			</BarChart>
		</ResponsiveContainer>
	</div>
);



const SummaryNumber = ({ label, value }) => (
	<div style={{ flexShrink: 1,  textAlign:'right' }}>
		<div style={{ fontSize: '13px' }}>{label}</div>
		<div style={{ fontSize: '48px', fontWeight: 100, lineHeight: '44px' }}>{value}</div>
	</div>
);


// WEBPACK FOOTER //
// ./src/components/ExperimentResults.js